import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getJson, postJson } from '../../helpers/RequestsHelper';

const WalletConnect = (props) => {

  const { t } = useTranslation()

  const [walletAddress, setWalletAddress] = useState()
  const [loading, setLoading] = useState()
  const [error, setError] = useState()

  const connectWallet = async () => {
    await window.ethereum.send('eth_requestAccounts');
    const accounts = await window.ethereum.request({ method: 'eth_accounts' });
    let wallet = accounts[0];
    setWalletAddress(wallet);

  }

  const checkNetwork = async () => {
    //const accounts = await window.ethereum.request({ method: 'eth_accounts' });
    const chainId = await window.ethereum.request({ method: 'eth_chainId' });
    //console.log(accounts)
    console.log(chainId)
    if (chainId != '0x89') {
      setError(<>Not connected to polygon mainnet.
        <button className="submit-btn-2" onClick={addPolygonTestnetNetwork}>Add Polygon network</button>
      </>)
    } else {
      await connectWallet()
    }
  }


  const addPolygonTestnetNetwork = async () => {
    try {
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: '0x89' }], // Hexadecimal version of 137, prefixed with 0x
      });

      await addTIME()
    } catch (error) {
      if (error.code === 4902) {
        try {
          await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [{
              chainId: '0x89', // Hexadecimal version of 137, prefixed with 0x
              chainName: "Polygon Mainnet",
              nativeCurrency: {
                name: "MATIC",
                symbol: "MATIC",
                decimals: 18,
              },
              rpcUrls: ["https://polygon-rpc.com/"],
              blockExplorerUrls: ["https://polygonscan.com/"],
              iconUrls: [""],

            }],
          });
          await addTIME()
        } catch (addError) {
          console.log('Did not add network');
        }
      }
    }
  }

  const addTIME = async () => {
    const tokenAddress = '0x91E15183685B4594B75FC2b8a1bb80a900A3909e'
    const tokenSymbol = '$TIME'
    const tokenDecimals = 18
    const tokenImage = '' //TODO: Add image http://placekitten.com/200/300';

    try {
      // wasAdded is a boolean. Like any RPC method, an error may be thrown.
      const wasAdded = await window.ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20', // Initially only supports ERC20, but eventually more!
          options: {
            address: tokenAddress, // The address that the token is at.
            symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
            decimals: tokenDecimals, // The number of decimals in the token
            image: tokenImage, // A string url of the token logo
          },
        },
      });

      if (wasAdded) {
        console.log('Thanks for your interest!');
      } else {
        console.log('$TIME was not added');
      }
    } catch (error) {
      console.log(error);
    }
  }


  if (loading) {
    return <div className="spinner-border" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  } else {
    return <div >

      <>Wallet: </>
      {error
        ? <small className='text-danger'>{error}</small>
        : window.ethereum
          ? walletAddress
            ? <>{walletAddress} {props.balance.balance >= 100 ? <button className="submit-btn-2" onClick={()=>props.withdrawToWallet(walletAddress)}>Withdraw to wallet</button> : <small className='text-danger'>You need at least 150 $TIME to withdraw</small>}</>
            : <><button className="submit-btn-2" onClick={checkNetwork}>Connect</button> If you cannot see $TIME in your wallet: <button className="submit-btn-2" onClick={addTIME}>Add $TIME to MetaMask</button> </>
          : <small>MetaMask not available. You need it if you want to withdraw to your wallet. You can install it from <a href="https://metamask.io/download/">here</a></small>
      }
    </div>
  }
}

export default WalletConnect
